import classes from './RealPlayInfo.module.scss';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';
const RealPlayInfo = () => {
  const { roleplay, ratingCriteria, selectedScenario } = RealPlayRecordDataHelper();

  return (
    <div className={classes.container}>
      <p className="heading4">About your {roleplay?.name}</p>

      <div className={classes.scenario}>
        <span>"{selectedScenario?.name}"</span>
        <p>{selectedScenario?.description}</p>
      </div>

      <div className={classes.ratingCriteriaRep}>
        <span>Rating criteria:</span>
        <ul>
          {(ratingCriteria ?? []).map((r) => (
            <li key={r?.uuid}>{r?.name}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default RealPlayInfo;
